<template>
  <calendesk-ai-assistant
    v-if="isVisible"
    :api-url="apiUrl"
    token-source="localStorage"
    token-key="accessToken"
    theme="light"
  />
</template>

<script>
import { mapGetters } from "vuex";
import { refreshToken } from "@/lib/calendesk-js-library/api/api-client";
import { tokenOperations } from "@/lib/calendesk-js-library/tools/token";

export default {
  name: "AiAssistant",
  computed: {
    ...mapGetters({
      isUserLogged: "auth/isUserLogged",
      isAdmin: "auth/isAdmin",
    }),
    apiUrl() {
      return process.env.VUE_APP_AI_GATEWAY_URL || null;
    },
    isVisible() {
      return (
        this.isUserLogged &&
        this.isAdmin &&
        !!this.apiUrl &&
        !!this.$config("ai_chat_widget_enabled")
      );
    },
  },
  mounted() {
    this._handleTokenRefresh = (event) => {
      refreshToken()
        .then((response) => {
          tokenOperations(response.data);
          event.detail.callback(response.data.access_token);
        })
        .catch(() => {
          event.detail.callback(null);
        });
    };
    document.addEventListener(
      "calendesk-auth-refresh-needed",
      this._handleTokenRefresh,
    );
  },
  beforeDestroy() {
    document.removeEventListener(
      "calendesk-auth-refresh-needed",
      this._handleTokenRefresh,
    );
  },
};
</script>
